import { Record, Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { option_type, tuple_type, string_type, uint32_type, record_type, bool_type, float64_type, union_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Qualities$1, Qualities_multipliers, Profession, SkillsModule_professionActive } from "./Skills.js";
import { map, fill, item as item_2, contains } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { equals, numberHash } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { max } from "../fable_modules/fable-library-js.4.29.0/Double.js";

export class Category extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Seeds", "Vegetable", "Fruit", "Flower", "Forage", "ArtisanGood", "Other"];
    }
}

export function Category_$reflection() {
    return union_type("StardewValleyStonks.Category", [], Category, () => [[], [], [], [], [], [], []]);
}

export function CategoryModule_multiplier(skills, _arg) {
    let matchResult;
    switch (_arg.tag) {
        case 2: {
            if (SkillsModule_professionActive(new Profession(0, []), skills)) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 1: {
            if (SkillsModule_professionActive(new Profession(0, []), skills)) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 3: {
            if (SkillsModule_professionActive(new Profession(0, []), skills)) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return 1.1;
        default: {
            let matchResult_1;
            if (_arg.tag === 5) {
                if (SkillsModule_professionActive(new Profession(1, []), skills)) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return 1.4;
                default:
                    return 1;
            }
        }
    }
}

export class Multipliers extends Record {
    constructor(ProfitMargin, BearsKnowledge, TillerForForagedFruit) {
        super();
        this.ProfitMargin = ProfitMargin;
        this.BearsKnowledge = BearsKnowledge;
        this.TillerForForagedFruit = TillerForForagedFruit;
    }
}

export function Multipliers_$reflection() {
    return record_type("StardewValleyStonks.Multipliers", [], Multipliers, () => [["ProfitMargin", float64_type], ["BearsKnowledge", bool_type], ["TillerForForagedFruit", bool_type]]);
}

export const MultipliersModule_common = new Multipliers(1, false, false);

export class Item extends Record {
    constructor(Id, Name, SellPrice, Category) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.SellPrice = SellPrice;
        this.Category = Category;
    }
}

export function Item_$reflection() {
    return record_type("StardewValleyStonks.Item", [], Item, () => [["Id", uint32_type], ["Name", string_type], ["SellPrice", uint32_type], ["Category", Category_$reflection()]]);
}

export const ItemModule_foragedFruitTillerPossible = new Uint32Array([410, 398]);

export function ItemModule_foragedFruitTillerActive(multipliers, item) {
    if (multipliers.TillerForForagedFruit) {
        return contains(item.Id, ItemModule_foragedFruitTillerPossible, {
            Equals: (x, y) => (x === y),
            GetHashCode: numberHash,
        });
    }
    else {
        return false;
    }
}

export function ItemModule_multiplier(skills, multipliers, forage, item) {
    return ((((forage && equals(item.Category, new Category(2, []))) && !ItemModule_foragedFruitTillerActive(multipliers, item)) ? 1 : CategoryModule_multiplier(skills, item.Category)) * multipliers.ProfitMargin) * ((multipliers.BearsKnowledge && (item.Id === 410)) ? 3 : 1);
}

function ItemModule_sellPriceAfterMultipliers(qualityMultiplier, multiplier, basePrice) {
    let value_5, value_2;
    return max(1, (value_5 = (multiplier * ((value_2 = (qualityMultiplier * basePrice), value_2 >>> 0))), value_5 >>> 0));
}

export function ItemModule_priceCalc(multiplier, basePrice, quality) {
    if (basePrice === 0) {
        return 0;
    }
    else {
        return ItemModule_sellPriceAfterMultipliers(item_2(quality, Qualities_multipliers.fields[0]), multiplier, basePrice);
    }
}

export function ItemModule_price(skills, multipliers, forage, item, quality) {
    return ItemModule_priceCalc(ItemModule_multiplier(skills, multipliers, forage, item), item.SellPrice, quality);
}

export function ItemModule_priceByQualityCalc(multiplier, basePrice) {
    if (basePrice === 0) {
        return new Qualities$1(fill(new Uint32Array(4), 0, 4, 0));
    }
    else {
        return new Qualities$1(map((quality) => ItemModule_sellPriceAfterMultipliers(quality, multiplier, basePrice), Qualities_multipliers.fields[0], Uint32Array));
    }
}

export function ItemModule_priceByQuality(skills, multipliers, forage, item) {
    return ItemModule_priceByQualityCalc(ItemModule_multiplier(skills, multipliers, forage, item), item.SellPrice);
}

export function ProcessorModule_seedMakerAccepts(item) {
    const matchValue = item.Category;
    switch (matchValue.tag) {
        case 2:
        case 1:
        case 3:
        case 4:
            return true;
        default:
            return item.Id === 417;
    }
}

export function ProcessorModule_seedMakerExpectedQuantity(seed) {
    return (0.975 * 2) + ((seed === 499) ? 0.005 : 0);
}

export class ProcessedItem extends Record {
    constructor(Item, Processor, Ratio) {
        super();
        this.Item = Item;
        this.Processor = Processor;
        this.Ratio = Ratio;
    }
}

export function ProcessedItem_$reflection() {
    return record_type("StardewValleyStonks.ProcessedItem", [], ProcessedItem, () => [["Item", uint32_type], ["Processor", string_type], ["Ratio", option_type(tuple_type(uint32_type, uint32_type))]]);
}

export class Product extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Jam", "Pickles", "Wine", "Juice", "SeedsFromSeedMaker", "Processed"];
    }
}

export function Product_$reflection() {
    return union_type("StardewValleyStonks.Product", [], Product, () => [[["Item", uint32_type]], [["Item", uint32_type]], [["Item", uint32_type]], [["Item", uint32_type]], [["seed", uint32_type]], [["Item", ProcessedItem_$reflection()]]]);
}

export function ProductModule_item(_arg) {
    let item;
    switch (_arg.tag) {
        case 1: {
            item = _arg.fields[0];
            break;
        }
        case 2: {
            item = _arg.fields[0];
            break;
        }
        case 3: {
            item = _arg.fields[0];
            break;
        }
        case 4: {
            item = _arg.fields[0];
            break;
        }
        case 5: {
            item = _arg.fields[0].Item;
            break;
        }
        default:
            item = _arg.fields[0];
    }
    return item;
}

export function ProductModule_name(getItem, product) {
    const name = getItem(ProductModule_item(product)).Name;
    switch (product.tag) {
        case 1:
            return `Pickled ${name}`;
        case 2:
            return `${name} Wine`;
        case 3:
            return `${name} Juice`;
        case 4:
            return name;
        case 5:
            return name;
        default:
            return `${name} Jam`;
    }
}

export function ProductModule_processor(_arg) {
    switch (_arg.tag) {
        case 2:
        case 3:
            return "Keg";
        case 4:
            return "Seed Maker";
        case 5:
            return _arg.fields[0].Processor;
        default:
            return "Preserves Jar";
    }
}

export function ProductModule_preservesQuality(getItem, qualityArtisanProducts, _arg) {
    switch (_arg.tag) {
        case 4:
            return false;
        case 5: {
            const p = _arg.fields[0];
            if (qualityArtisanProducts) {
                if (equals(getItem(p.Item).Category, new Category(5, []))) {
                    return true;
                }
                else {
                    return p.Item === 395;
                }
            }
            else {
                return false;
            }
        }
        default:
            return qualityArtisanProducts;
    }
}

export function ProductModule_outputQuality(getItem, qualityArtisanProducts, quality, product) {
    if (ProductModule_preservesQuality(getItem, qualityArtisanProducts, product)) {
        return quality | 0;
    }
    else {
        return 0;
    }
}

export function ProductModule_preservesJarPrice(basePrice) {
    return (basePrice * 2) + 50;
}

export function ProductModule_winePrice(basePrice) {
    return basePrice * 3;
}

export function ProductModule_juicePrice(basePrice) {
    const value_2 = 2.25 * basePrice;
    return value_2 >>> 0;
}

function ProductModule_productPrice(_arg) {
    switch (_arg.tag) {
        case 2:
            return ProductModule_winePrice;
        case 3:
            return ProductModule_juicePrice;
        case 4:
        case 5:
            return (x) => x;
        default:
            return ProductModule_preservesJarPrice;
    }
}

function ProductModule_multiplierAndPrice(getItem, skills, multipliers, product) {
    let matchResult, item, itemId;
    switch (product.tag) {
        case 1: {
            matchResult = 0;
            item = product.fields[0];
            break;
        }
        case 2: {
            matchResult = 0;
            item = product.fields[0];
            break;
        }
        case 3: {
            matchResult = 0;
            item = product.fields[0];
            break;
        }
        case 4: {
            matchResult = 1;
            itemId = product.fields[0];
            break;
        }
        case 5: {
            matchResult = 1;
            itemId = product.fields[0].Item;
            break;
        }
        default: {
            matchResult = 0;
            item = product.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return [CategoryModule_multiplier(skills, new Category(5, [])) * multipliers.ProfitMargin, ProductModule_productPrice(product)(getItem(item).SellPrice)];
        default: {
            const item_1 = getItem(itemId);
            return [ItemModule_multiplier(skills, multipliers, false, item_1), item_1.SellPrice];
        }
    }
}

export function ProductModule_priceAndQuality(getItem, skills, multipliers, qap, quality, product) {
    const patternInput = ProductModule_multiplierAndPrice(getItem, skills, multipliers, product);
    const quality_1 = ProductModule_outputQuality(getItem, qap, quality, product) | 0;
    return [ItemModule_priceCalc(patternInput[0], patternInput[1], quality_1), quality_1];
}

export function ProductModule_price(getItem, skills, multipliers, qap, quality, product) {
    return ProductModule_priceAndQuality(getItem, skills, multipliers, qap, quality, product)[0];
}

export function ProductModule_priceByQuality(getItem, skills, multipliers, qap, product) {
    const patternInput = ProductModule_multiplierAndPrice(getItem, skills, multipliers, product);
    const price = patternInput[1];
    const multiplier = patternInput[0];
    if (ProductModule_preservesQuality(getItem, qap, product)) {
        return ItemModule_priceByQualityCalc(multiplier, price);
    }
    else {
        return new Qualities$1(fill(new Uint32Array(4), 0, 4, ItemModule_priceCalc(multiplier, price, 0)));
    }
}

export function ProductModule_quantityPerInput(product) {
    let matchResult, seed, i, o;
    switch (product.tag) {
        case 4: {
            matchResult = 0;
            seed = product.fields[0];
            break;
        }
        case 5: {
            if (product.fields[0].Ratio != null) {
                matchResult = 1;
                i = product.fields[0].Ratio[0];
                o = product.fields[0].Ratio[1];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return ProcessorModule_seedMakerExpectedQuantity(seed * 1);
        case 1:
            return o / i;
        default:
            return 1;
    }
}

export function ProductModule_normalizedPrice(getItem, skills, multipliers, qap, quality, product) {
    return ProductModule_price(getItem, skills, multipliers, qap, quality, product) * ProductModule_quantityPerInput(product);
}

export function ProductModule_normalizedPriceByQuality(getItem, skills, multipliers, qap, product) {
    const quantity = ProductModule_quantityPerInput(product);
    return new Qualities$1(map((price) => (price * quantity), ProductModule_priceByQuality(getItem, skills, multipliers, qap, product).fields[0], Float64Array));
}

//# sourceMappingURL=Items.js.map
